<template>
  <div id="note-tab">
    <div class="panel">
      <div class="notes">
        <p :key="note.id" v-for="note in notes">
          <span>{{ moment(note.createdAt, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]').format('DD/MM/YYYY HH:mm') }}</span>
          <span> - </span>
          <span>{{ note.createdBy.firstName }} {{ note.createdBy.lastName }}</span>
          <span>: </span>
          <span>{{ note.content }}</span>
        </p>
      </div>
      <text-input
        :placeholder="$t('ENTER_NOTES')"
        icon-position="right"
        v-model="note"
        @keydown.enter="submit"
      >
        <template v-slot:icon>
          <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="submit" />
        </template>
      </text-input>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { ref, watch } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TextInput from '@/components/TextInput';

import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import ClientDetailService from '../../ClientDetailServices';

const { useState, useActions } = createNamespacedHelpers('clientDetail');

export default {
  name: 'NoteTab',
  components: {
    TextInput,
    FontAwesomeIcon,
  },
  setup() {
    const { notes, targetingClient: client } = useState(['notes', 'targetingClient']);
    const { getClientNotes } = useActions(['getClientNotes']);

    const note = ref('');

    watch(client, (newDetail) => {
      if (newDetail && newDetail.id) {
        getClientNotes();
      }
    }, {
      immediate: true
    });

    const submit = async () => {
      if (note.value.trim('') !== '') {
        await ClientDetailService.addClientNotes(client.value.id, note.value);
        getClientNotes();
        note.value = '';
      }
    };

    return {
      note,
      notes,
      submit,
      moment,
      faPaperPlane,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#note-tab {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .panel {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid $alto;
    flex: 1;
    display: flex;
    flex-direction: column;

    .notes {
      padding: 10px 20px;
      font-size: 13px;
      flex:1;
      overflow-y: scroll;

      p {
        margin: 0;

        span {
          color: $lavenderGrey;

          &:last-child {
            color: $independence;
          }
        }
      }
    }

    .icon {
      transition: all .2s ease-in-out;
      cursor: pointer;

      &:hover {
        color: $paradisePink;
      }
    }
  }

  /deep/ .text-input input {
    border: 0;
    border-top: 1px solid $alto;
    border-radius: 0;
  }
}
</style>
